import { render, staticRenderFns } from "./chatModal.vue?vue&type=template&id=7706c256&scoped=true"
import script from "./chatModal.vue?vue&type=script&lang=js"
export * from "./chatModal.vue?vue&type=script&lang=js"
import style0 from "./chatModal.vue?vue&type=style&index=0&id=7706c256&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7706c256",
  null
  
)

export default component.exports